module.exports = __webpack_public_path__ + "media/application/images/services/secondary_nav/our-services-68b5daf4903cb135eaaca3caa7ce6ad5.jpg";